import { render } from "./FormRoofFinishingView.vue?vue&type=template&id=79cc4178"
import script from "./FormRoofFinishingView.vue?vue&type=script&lang=js"
export * from "./FormRoofFinishingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__